import { Avatar, AvatarFallback, AvatarImage } from '@features/ui';
import { useAuthStore } from '@stores/authStore.ts';
import { FC } from 'react';
import { cn } from '@lib/utils.ts';

interface AvatarHeaderProps {
  onClick?: () => void;
  className?: string;
}
export const AvatarHeader: FC<AvatarHeaderProps> = ({ onClick, className }) => {
  const { auth } = useAuthStore();

  if (!auth.user) return <></>;

  return (
    <Avatar className={cn('w-[44px] h-[44px]', className)} onClick={onClick}>
      <AvatarImage alt="Profile picture" src={auth.user?.avatar ?? ''} />
      <AvatarFallback className={'bg-white text-muted'}>
        {auth.user.first_name?.slice(0, 2)}
      </AvatarFallback>
    </Avatar>
  );
};
